
import { defineComponent } from 'vue'

const BUSINESS_FEATURES = [
  { icon: 'check', label: 'Everything included in the Business plan', emphasize: false },
  { icon: 'check', label: 'Full access to the new AI Code Review platform', emphasize: false },
  {
    icon: 'plus',
    label: '$10 per contributor per month complementary AI Review credit',
    emphasize: true
  }
] as const

const STARTER_FEATURES = [
  {
    icon: 'check',
    label: 'Everything included in the current Starter and Business plans',
    emphasize: false
  },
  { icon: 'check', label: 'Full access to the new AI Code Review platform', emphasize: false },
  {
    icon: 'plus',
    label: '$10 per contributor per month complementary AI Review credit',
    emphasize: true
  }
] as const

export default defineComponent({
  name: 'MigrateTeamPlanModal',
  props: {
    currentPriceLabel: {
      type: String,
      required: true
    },
    newPriceLabel: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isStarterPlan: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    features() {
      return this.isStarterPlan ? STARTER_FEATURES : BUSINESS_FEATURES
    },
    ctaText(): string {
      return this.isStarterPlan ? 'Confirm and upgrade plan' : 'Confirm and migrate plan'
    },
    ctaLoadingText(): string {
      return this.isStarterPlan ? 'Upgrading...' : 'Migrating...'
    }
  },
  methods: {
    handleClose() {
      if (!this.loading) {
        this.$emit('close')
      }
    }
  }
})
